import { useMemo } from "react";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { CaseFromAlertResponse } from "interfaces/alert";

export interface PostAlertCaseResponse {
  loading: boolean;
  error: boolean;
  postCaseCallback(): Promise<CaseFromAlertResponse>;
}

interface PostCaseResponse {
  loading: boolean;
  error: boolean;
  postCallback(): Promise<CaseFromAlertResponse>;
}

/**
 * Hook for posting a new case with the alert info included to the AI Hub API
 * @param alertId the id of the alert
 */
export const usePostAlertCase = (alertId: number): PostAlertCaseResponse => {
  const url = useMemo(() => `alerts/${alertId}/create_case_with_event/`, [
    alertId
  ]);

  const { loading, error, postCallback }: PostCaseResponse = useFetchPostV2(
    url
  );

  return { loading, error, postCaseCallback: postCallback };
};
